import { render, staticRenderFns } from "./doughnut-chart.vue?vue&type=template&id=338dbf85&scoped=true&"
import script from "./doughnut-chart.vue?vue&type=script&lang=ts&"
export * from "./doughnut-chart.vue?vue&type=script&lang=ts&"
import style0 from "./doughnut-chart.vue?vue&type=style&index=0&id=338dbf85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338dbf85",
  null
  
)

export default component.exports